import { Modal, Radio, VStack, Text, Button, TextArea } from "native-base";
import { useRef, useState } from "react";
import useDialogA11y from "../hooks/useDialogA11y";

export default function RaiseConcernModal({ raiseModel, setRaiseModel }) {
  const dialogRef = useRef(null);
  const handleClose = () => { setSelected(""); setOtherText(""); setRaiseModel(false); };
  useDialogA11y(dialogRef, handleClose, raiseModel);

  const [selected, setSelected] = useState("");
  const [otherText, setOtherText] = useState("");

  const handleCancel = handleClose;

  const handleSubmit = () => {
    if (selected === "other" && !otherText.trim()) {
      alert("Please enter the issue in the text area.");
      return;
    }

    const finalValue = selected === "other" ? `Other: ${otherText}` : selected;

    console.log("Submitted Reason:", finalValue);
    handleCancel(); // Close modal
  };

  if (!raiseModel) return null;

  return (
    <div ref={dialogRef} role="dialog" aria-modal="true" aria-label="Report an issue">
    <Modal isOpen onClose={handleCancel}>
      <Modal.Content maxWidth="400px" borderRadius="2xl" bg="coolGray.50">
        <Modal.Body p={6}>
          <Text
            fontSize="lg"
            fontWeight="bold"
            mb={4}
            color="coolGray.800"
            textAlign="center"
          >
            Please tell us the issue
          </Text>

          <VStack space={3}>
            <Radio.Group
              name="cancelReason"
              accessibilityLabel="Choose reason for cancellation"
              value={selected}
              onChange={(value) => setSelected(value)}
            >
              {[
                "No Show",
                "Payment",
                "User Incorrectly Represented",
                "Not Able to Deliver",
                "Other",
              ].map((reason) => (
                <Radio
                  key={reason}
                  value={reason === "Other" ? "other" : reason}
                  size="md"
                  my={1}
                  _checked={{ borderColor: "primary.600", bg: "primary.100" }}
                  _text={{ fontSize: "md", fontWeight: "medium" }}
                >
                  {reason}
                </Radio>
              ))}
            </Radio.Group>

            {selected === "other" && (
              <TextArea
                mt={2}
                placeholder="Describe the issue..."
                value={otherText}
                onChangeText={setOtherText}
                h={20}
                borderColor="primary.300"
                _focus={{ borderColor: "primary.500" }}
              />
            )}
          </VStack>

          <Button.Group mt={6} space={2} justifyContent="center">
            <Button
              variant="outline"
              colorScheme="coolGray"
              onPress={handleCancel}
            >
              Cancel
            </Button>
            <Button colorScheme="primary" onPress={handleSubmit}>
              Submit
            </Button>
          </Button.Group>
        </Modal.Body>
      </Modal.Content>
    </Modal>
    </div>
  );
}
